module.exports = __webpack_public_path__ + "img/user-icon-placeholder.fd798c9e.svg";